import React from 'react';

const DownloadReportModal = ({ open, onClose, onSubmit }) => {
  const today = new Date().toISOString().split('T')[0];

  return (
    <div className={`modal-overlay ${open ? 'active' : ''}`} onClick={onClose} data-testid="download-report-modal">
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-icon primary">⤓</div>
        <div className="modal-title">Download Laporan CRM</div>
        <div className="modal-sub" style={{ marginBottom: '20px' }}>
          Pilih rentang tanggal untuk visualisasi laporan. Laporan akan di-generate dalam format PDF/CSV.
        </div>
        <form onSubmit={onSubmit}>
          <div style={{ display: 'flex', gap: '16px' }}>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Tanggal Mulai</label>
              <input type="date" name="startDate" className="form-control" required defaultValue={today} data-testid="report-start-date" />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Tanggal Akhir</label>
              <input type="date" name="endDate" className="form-control" required defaultValue={today} data-testid="report-end-date" />
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn-modal btn-cancel" onClick={onClose} data-testid="download-report-cancel">Batal</button>
            <button type="submit" className="btn-modal btn-gold" data-testid="download-report-submit">Download</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DownloadReportModal;
